<ng-container *ngIf="isLoading$ | async">
    <div class="progress progress-modal">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
            style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</ng-container>
<div class="container">
    <div class="row">
        <div class="appointment-item appointment-item-two">
            <div class="appointment-form">
                <div class="row " >
                    <div class="col-lg-1"></div>
                    <div class="col-lg-6">
                        <h4>{{ language == 'en'? ' Change your password ':' تغير كلمة المرور الخاصة بك ' }}</h4>
                        <p>{{ language == 'en'? ' Change your password periodically in order to keep your account secure. ':' قم بتغيير كلمة المرور الخاصة بك بشكل دوري للحفاظ على أمان حسابك.' }}</p>
                    </div>
                    <div class="col-lg-4">
                        <!-- <button  class="custom-btn btn-13 " (click)="ChangePassword()">{{ 'AUTH.GENERAL.CHANGEPASSWORD' | translate}}</button> -->
                        <button  style="font-weight: bold;width: 220px;" class="btn btn-primary btn-lg" (click)="ChangePassword()"> {{ 'AUTH.GENERAL.CHANGEPASSWORD' | translate}}</button>
                    </div>
                </div>
                <div class="row " *ngIf="!roles.includes('DoctorVisits')">
                    <div class="col-lg-12" style="margin-bottom: 30px;"><hr></div>
                    <div class="col-lg-1" ></div>
                    <div class="col-lg-6">
                        <h4>{{ language == 'en'? ' Delete your account ':'حذف حسابك' }}</h4>
                        <p>{{ language == 'en'? ' All data of your account will be erased. You can activate it again ':' سيتم مسح جميع بيانات حسابك. يمكنك تنشيطه مرة أخرى.' }}</p>
                    </div>
                    <div class="col-lg-4">
                        <!-- <button  class="custom-btn btn-7 " (click)="DeleteAccount()">{{ 'COMMON.DELETEACCOUNT' | translate}}</button> -->
                        <button style="font-weight: bold;width: 220px;" class="btn btn-danger btn-lg" (click)="DeleteAccount()"> {{ 'COMMON.DELETEACCOUNT' | translate}}</button>
                    </div>
                    
                </div>
            </div>
        </div>

    </div>
</div>